import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface EmailVerificationGuardProps {
  children: React.ReactNode;
}

export function EmailVerificationGuard({ children }: EmailVerificationGuardProps) {
  const { user } = useAuth();

  // If user hasn't verified their email, redirect to verification page
  if (!user?.email_verified_at) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}
